import React from 'react';
import Header from './ForgotPasswordConfirmationHeader';
import Form from './ForgotPasswordConfirmationForm';
import Footer from './ForgotPasswordConfirmationFooter';
import { SWrapper } from '../styles/Login.styled';
import LoginLayout from '@/presentation/layout/LoginLayout';

const ForgotPasswordConfirmation: React.FC = () => {
  return (
    <LoginLayout>
      <SWrapper>
        <Header />
        <Form />
        <Footer />
      </SWrapper>
    </LoginLayout>
  );
};

export default ForgotPasswordConfirmation;
